import { errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
const LEDGER_LIMIT = 200;
/** Platform console: running ledger of money paid to / received from one delivery partner. */
export class PartnerLedgerViewModel extends ViewModel {
    client;
    slug;
    constructor(client, slug) {
        super({ ledger: null, message: null, error: null });
        this.client = client;
        this.slug = slug;
    }
    async load() {
        try {
            this.setState({ ledger: await this.client.listPartnerLedger(this.slug, LEDGER_LIMIT) });
        }
        catch (e) {
            this.setState({ error: errorMessage(e, "Failed to load ledger") });
        }
    }
    /** Surface a form-validation problem through the same status line. */
    fail(message) {
        this.setState({ message: null, error: message });
    }
    clearStatus() {
        this.setState({ message: null, error: null });
    }
    /** Returns true when the entry was saved (caller clears its form fields). */
    async addEntry(input) {
        this.clearStatus();
        try {
            await this.client.addPartnerLedgerEntry(this.slug, input);
        }
        catch (e) {
            this.setState({ error: errorMessage(e, "Failed to add entry") });
            return false;
        }
        this.setState({ message: "Entry added." });
        await this.load();
        return true;
    }
}
//# sourceMappingURL=PartnerLedgerViewModel.js.map